



  <div class="publicLandingEdit">
    <!-- Show an error message if there is one -->
    <div *ngIf="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
  
    <!-- If no error, display the retrieved content -->
    <div *ngIf="!errorMessage">
      <div [innerHTML]="safeContent"></div>
    
    </div>
  
  </div>

  <br />
  <!-- <a routerLink="dashboard" class="btn  btn-sm btn-secondary">
      Take me Back
    </a>  -->


<div class="container">
     
</div>
    <style>
      video {
        max-width: 100%;  /* Ensure the video doesn't exceed the container width */
        height: auto;     /* Maintain aspect ratio */
        display: block;   /* Prevent inline whitespace issues */
        margin: 0 auto;   /* Center the video horizontally (if desired) */
      }
    </style>
    
    <!-- Video element that plays automatically -->
    <video autoplay muted loop playsinline controls>
   
      <source src="../../../../assets/video/boyandGrandma.mp4" type="video/mp4">
      Your browser does not support the video tag.
    </video>